"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailVerificationEmailResult = void 0;
const base_update_result_dto_1 = require("../../../../common/dtos/base-update-result.dto");
class SendEmailVerificationEmailResult extends base_update_result_dto_1.BaseUpdateResult {
}
exports.SendEmailVerificationEmailResult = SendEmailVerificationEmailResult;
